import { render, staticRenderFns } from "./ConfirmationContext.vue?vue&type=template&id=a8c736f6&scoped=true"
import script from "./ConfirmationContext.vue?vue&type=script&lang=js"
export * from "./ConfirmationContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c736f6",
  null
  
)

export default component.exports